import { withState } from 'recompose';

export default withState('searchBy', 'updateSearchBy', '');
